<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'

    import type { IAddress } from 'wdom/services/contacts'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import Country from 'wdom/components/contacts/Country.svelte'
    import InternationalPhone from 'wdom/components/contacts/InternationalPhone.svelte'
    import PostalCode from 'wdom/components/contacts/PostalCode.svelte'
    import Province from 'wdom/components/contacts/Province.svelte'

    interface Props {
        address: IAddress | null | undefined
    }

    let { address }: Props = $props()
</script>

<style>
    p.phone-list > span {
        display: block;
    }
</style>

{#if !address}
    <LoadingPattern pattern={['x', 'x', '-', 'x', 'x', 'x']} />
{:else}
    <p>
        {address.name}{#if address.org}, {address.org}{/if}
        {#if address.email}<br />{address.email}{/if}
    </p>
    {#if address.voice || address.mobile || address.fax}
        <p class="phone-list">
            {#if address.voice}
                <span>{$_('Voice:')} <InternationalPhone phone={address.voice} /></span>
            {/if}
            {#if address.mobile}
                <span>{$_('Mobile:')} <InternationalPhone phone={address.mobile} /></span>
            {/if}
            {#if address.fax}
                <span>{$_('Fax:')} <InternationalPhone phone={address.fax} /></span>
            {/if}
        </p>
    {/if}
    <p>
        {address.street[0]}
        {#if address.street.length > 1}<br />{address.street[1]}{/if}
        {#if address.city || address.sp || address.postal_code}
            <br />{address.city} <Province contact={address} /> <PostalCode contact={address} />
        {/if}
        {#if address.country}<br /><Country contact={address} />{/if}
    </p>
{/if}
